import { useMutation } from 'react-query'
import FilesAndDirectoriesService from '../../../services/FilesAndDirectoriesService'

type CreateDirectoryPayload = {
  organization: string
  project: string
  name: string
  directoryPath?: string
}

export const useCreateDirectory = () => {
  return useMutation<any, Error, CreateDirectoryPayload>({
    mutationKey: ['create-directory'],

    mutationFn: ({ organization, project, name, directoryPath }) =>
      FilesAndDirectoriesService.addDirectory(organization, project, name, directoryPath),
    // onSuccess: () => {
    //   queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    // },
  })
}
